import clsx from "clsx"
import { Trans } from "@lingui/macro"

import { Image } from "@src/components/atoms/Image"
import owlie from "@src/assets/owlie.webp"

type ErrorProps = {
  code: number
  actions?: React.ReactNode
  className?: string
  title?: React.ReactNode
  description?: React.ReactNode
}

export const Error = ({
  code,
  actions,
  className,
  title,
  description,
}: ErrorProps) => {
  return (
    <div
      className={clsx(
        "mx-auto flex flex-row items-center justify-center gap-3 p-4 lg:p-16",
        className,
      )}
    >
      <Image src={owlie} alt="owlie" className="h-auto w-36" />
      <div className="flex flex-col gap-3">
        {code === 0 && (
          <h4>
            <Trans id="something_went_wrong">
              Something went wrong! Please try refreshing the page. If the error
              persists, please contact us!
            </Trans>
          </h4>
        )}
        {code === 403 && (
          <>
            <h1 className="text-bold">403</h1>
            <h4>
              {title ?? <Trans id="forbidden">Forbidden</Trans>}
            </h4>
            <p>
              {description ?? (
                <Trans id="you_dont_have_permission">
                  You don't have permission to access this page
                </Trans>
              )}
            </p>
          </>
        )}
        {code === 404 && (
          <>
            <h1 className="text-bold">404</h1>
            <h4>
              <Trans id="page_not_found">Page Not Found</Trans>
            </h4>
            <p>
              <Trans id="page_not_found_description">
                The page you're looking for doesn't exist or has been moved.
              </Trans>
            </p>
          </>
        )}

        {actions}
      </div>
    </div>
  )
}
